import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../../components/layout/Loading";
import { closeDialog } from "../../../components/dialog/dialogSlice";
import IconButton from "../../../components/common/IconButton";
import { checkAcessRights } from "../../../_helper/helper";
import { EDIT_ACCESS } from "../../../_contstants/common";

import { getAllActiveUsers } from "../../user/services/user.services";
// import { setQuotationInformation } from "../quotation/quotationSlice";
import ButtonEdit from "../../../components/drawer/ButtonEdit";
import LinkEdit from "../../../components/drawer/LinkEdit";

import {
  clearCurrentPage,
  setCurrentPage,
  setPageLimit,
} from "../../pagination/paginationSlice";
import {
  setActiveTabIndex,
  setfilterFollowupsStageID,
} from "../dashboardSlice";
import { getDashboardSeemoreFollowups } from "../services/dashboard.services";
import { IFollowup } from "../dashboardModel";
import { FiEdit } from "react-icons/fi";

const DashboardFollowups: React.FC = () => {
  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0px 20px",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Follow-ups List
          </Typography.h4>
        </GridLayoutItem>
        <GridLayoutItem>
          <FollowupsGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const FollowupsGridComponent: React.FC = () => {
  const isFollowUpRef = useRef(true);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const activeTab = location.state?.activeTab;
  const FromDate = location.state.FromDate;
  const ToDate = location.state.ToDate;

  const [followupsdata, setFollowupsdataData] = React.useState<
    IFollowup[] | null
  >(null);
  const isLeadEditAccess = checkAcessRights("/lead", EDIT_ACCESS);
  const isInquiryEditAccess = checkAcessRights("/inquiry", EDIT_ACCESS);

  const activeTabIndex = useAppSelector(
    (state) => state.dashboard.activeTabIndex
  );

  const loading = useAppSelector((state) => state.dashboard.loading);

  const DashboardSeeMoreInquiryFollowups = useAppSelector(
    (state) => state.dashboard.DashboardSeeMoreInquiryFollowups
  );
  const DashboardSeeMoreLeadFollowups = useAppSelector(
    (state) => state.dashboard.DashboardSeeMoreLeadFollowups
  );

  const dateFilter = useAppSelector((state) => state?.dashboard?.dateFilter);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    dispatch(getAllActiveUsers());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  useEffect(() => {
    if (isFollowUpRef.current) {
      dispatch(setActiveTabIndex(+activeTab));
      isFollowUpRef.current = false;
    }
  }, []);

  useEffect(() => {
    const payload = {
      FromDate: dateFilter?.FromDate ? dateFilter?.FromDate : FromDate,
      ToDate: dateFilter?.ToDate ? dateFilter?.ToDate : ToDate,
    };
    dispatch(getDashboardSeemoreFollowups(payload));
  }, [pageLimit, currentPage]);

  useEffect(() => {
    if (activeTabIndex === 0) {
      setFollowupsdataData(DashboardSeeMoreLeadFollowups);
    } else {
      setFollowupsdataData(DashboardSeeMoreInquiryFollowups);
    }
  }, [
    DashboardSeeMoreInquiryFollowups,
    DashboardSeeMoreLeadFollowups,
    activeTabIndex,
  ]);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEdit = (data: any) => {
      navigate("/inquiry/edit", {
        state: {
          InquiryID: data?.ID,
          RequirementType: data?.RequirementType,
        },
      });
    };
    return (
      <td
        className={`action-td ${props.className}`}
        style={{ ...props.style, right: 0 }}
      >
        {props.dataItem?.FollowupType === "LEAD" ? (
          <>
            {isLeadEditAccess && (
              <ButtonEdit ID={props.dataItem.ID} drawerName="leadForm" />
            )}
          </>
        ) : (
          <>
            {isInquiryEditAccess && (
              <IconButton
                type="button"
                fillMode="flat"
                size="small"
                title="Edit Inquiry"
                onClick={() => handleEdit(props.dataItem)}
                icon={FiEdit}
                iconClassName="absolute-position"
                iconStyle={{ fontSize: "20px" }}
              />
            )}

            {/* <IconButton
              type="button"
              fillMode="flat"
              size="small"
              title="Create Inquiry"
              onClick={() => handleEdit(props.dataItem.ID)}
              icon={FaEdit}
              iconClassName="absolute-position"
              iconStyle={{ fontSize: "24px" }}
            /> */}
          </>
        )}
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 5 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const handleTabChange = (index: number) => {
    dispatch(clearCurrentPage());
    dispatch(setActiveTabIndex(index));
    dispatch(setfilterFollowupsStageID(index));
  };
  const gridRef = useRef<any>(null);
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div
        style={{
          marginTop: 10,
          padding: "10px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          boxShadow: "0 0 10px gainsboro",
        }}
      >
        <div style={{ display: "flex", gap: 10 }} className="mt-1 mb-3">
          <Button
            themeColor={"primary"}
            fillMode={activeTabIndex === 0 ? "solid" : "outline"}
            onClick={() => handleTabChange(0)}
          >
            Leads
          </Button>
          <Button
            themeColor={"primary"}
            fillMode={activeTabIndex === 1 ? "solid" : "outline"}
            onClick={() => handleTabChange(1)}
          >
            Inquiries
          </Button>
        </div>
        {/* {LeadList && LeadList.length ? ( */}
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 150px)" }}
          className="responsive-table"
          filterable={false}
          data={followupsdata}
          total={followupsdata?.length}
          skip={currentPage * pageLimit}
          take={pageLimit}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 50, 100, 500],
            pageSizeValue: pageLimit,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="Name"
            title="Name"
            width={300}
            cell={(props: any) => (
              <td>
                {isLeadEditAccess && props.dataItem.FollowupType === "LEAD" ? (
                  <LinkEdit ID={props.dataItem.ID} drawerName="leadForm">
                    <>
                      <div className="hoverableName">
                        {props.dataItem?.Name}
                      </div>
                      <p className="m-0"> {props.dataItem?.MobileNo}</p>
                      <p className="m-0"> {props.dataItem?.EmailID}</p>
                    </>
                  </LinkEdit>
                ) : isInquiryEditAccess &&
                  props.dataItem.FollowupType === "INQUIRY" ? (
                  <>
                    <div
                      className="hoverableName"
                      onClick={() =>
                        navigate("/inquiry/edit", {
                          state: {
                            InquiryID: props.dataItem?.ID,
                            RequirementType: props.dataItem?.RequirementType,
                          },
                        })
                      }
                    >
                      {props.dataItem?.Name}
                    </div>
                    <p className="m-0"> {props.dataItem?.MobileNo}</p>
                    <p className="m-0"> {props.dataItem?.EmailID}</p>
                  </>
                ) : (
                  <div className="normalName">
                    <p className="m-0">{props.dataItem?.Name}</p>
                    <p className="m-0"> {props.dataItem?.MobileNo}</p>
                    <p className="m-0"> {props.dataItem?.EmailID}</p>
                  </div>
                )}
              </td>
            )}
          />
          <Column field="FollowupDate" title="Followup Date" width={200} />
          <Column field="FollowupTime" title="Followup Time" width={200} />
          <Column field="Remarks" title="Remarks" width={200} />
          <Column field="FollowupStatus" title="Followup Status" width={200} />
          {((activeTabIndex === 0 && isLeadEditAccess) ||
            (activeTabIndex === 1 && isInquiryEditAccess)) && (
            <Column
              field="ID"
              title="Actions"
              cell={MyEditCommandCell}
              width={"100px"}
              filterable={false}
              locked={true}
            />
          )}
        </KendoGrid>
      </div>
    </>
  );
};

export default DashboardFollowups;
